import { apiSlice } from '../../api/apiSlice';
import {
    ProfileDetailsParams,
    ProfileDetailsResponse,
} from './profileDetailsApiSliceTypes';

const profileDetailsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProfileDetails: builder.query<
            ProfileDetailsResponse,
            ProfileDetailsParams
        >({
            query: (params) => ({
                url: '/profile/account',
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
            providesTags: (result, error, params) => {
                return result ? [{ type: 'profile', id: result.id }] : [];
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetProfileDetailsQuery, useLazyGetProfileDetailsQuery } =
    profileDetailsApiSlice;
